import { createSlice } from '@reduxjs/toolkit';
import { Message } from '@iqmaxx/shared';

interface MessagesState {
  messages: Message[];
  loading: boolean;
  error: string | null;
}

const initialState: MessagesState = {
  messages: [],
  loading: false,
  error: null,
};

const messagesSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    // Add message reducers here
  },
});

export default messagesSlice.reducer;
